import React from 'react';
import { WorkspaceProps } from 'common/types/search';
import { workspaceStore } from '../../../../../../../stores/WorkspaceStore';
import { ReactComponent as Chevron } from '../../../../../../../assets/icons/chevron.svg';
import { ReactComponent as WorkspaceIcon } from '../../../../../../../assets/icons/redesign_workspace_icon.svg';
import CoworkingSpaceIcon from '../../../../../../../assets/icons/redesign_workspace_coworking.png';
import AirportIcon from '../../../../../../../assets/icons/redesign_workspace_airport.png';
import PrivateOfficeIcon from '../../../../../../../assets/icons/redesign_workspace_private.png';
import VirtualOfficeIcon from '../../../../../../../assets/icons/redesign_workspace_virtual.png';
import styles from './WorkspaceFilter.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';

const switches = {
  numSpaces: 'Any Workspace',
  privateOfficeCount: 'Private Office',
  deskCount: 'Coworking Space',
  virtualOfficeCount: 'Virtual Office',
  loungeCount: 'Airport Lounge',
};

const requestSwitches = {
  privateOfficeCount: 'private_offices',
  deskCount: 'desks',
  virtualOfficeCount: 'virtual_offices',
  loungeCount: 'lounge',
  numSpaces: 'any',
};

const WorkspaceFilter: React.FC<WorkspaceProps> = ({ onWorkspaceHandler }) => {
  const { setAnyWorkspaceChecked } = workspaceStore;

  const { workspaceType, setWorkspaceType, spacesCount } = useResultListContext();

  const [isFilterVisible, setIsFilterVisible] = React.useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevIsFilterVisible) => !prevIsFilterVisible);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.name;
    const isChecked = event.target.checked;

    if (key === 'numSpaces') {
      setWorkspaceType(() => ({
        deskCount: isChecked,
        privateOfficeCount: isChecked,
        virtualOfficeCount: isChecked,
        loungeCount: isChecked,
      }));
      setAnyWorkspaceChecked(isChecked);
      onWorkspaceHandler([
        requestSwitches.deskCount,
        requestSwitches.privateOfficeCount,
        requestSwitches.virtualOfficeCount,
        requestSwitches.loungeCount,
      ]);
    } else {
      setWorkspaceType((prevState) => ({ ...prevState, [key]: isChecked }));
      setAnyWorkspaceChecked(false);

      const checkedValues = Object.entries({ ...workspaceType, [key]: isChecked })
        .filter(([, value]) => value)
        .map(([el]) => requestSwitches[el as keyof typeof requestSwitches]);

      onWorkspaceHandler(checkedValues);
    }
  };

  return (
    <button className={styles.container} onClick={toggleFilterVisibility} type="button">
      <div className={styles.heading}>
        <div className={styles.toggle}>
          <WorkspaceIcon />
          Workspace
        </div>
        <Chevron style={{ transform: !isFilterVisible ? 'rotate(270deg)' : 'none' }} />
      </div>
      {isFilterVisible && (
        <div
          className={styles.container__filters}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {/* if need to hide 0-value filters, import spacesCount from useContent above and use instead of switches */}
          {Object.entries(switches).map(([key, value]) => {
            if (key === 'numSpaces' || key === 'numSpacesFiltered') {
              return null;
            }

            return (
              <label
                key={key}
                className={
                  !spacesCount[key]
                    ? styles.container__filters__option_unavailable
                    : workspaceType[key]
                    ? styles.container__filters__option_active
                    : styles.container__filters__option
                }
              >
                <div>
                  {key === 'deskCount' ? <img src={CoworkingSpaceIcon} alt={key} /> : key === 'privateOfficeCount' ? <img src={PrivateOfficeIcon} alt={key} /> : key === 'virtualOfficeCount' ? <img src={VirtualOfficeIcon} alt={key} /> : <img src={AirportIcon} alt={key} />}
                  <input
                    checked={workspaceType[key] || false}
                    id={key}
                    name={key}
                    onChange={handleCheckboxChange}
                    type="checkbox"
                    disabled={!spacesCount[key]}
                  />
                </div>
                <span className={styles.container__filters__option_text}>
                  {switches[key as keyof typeof switches]}
                </span>
              </label>
            );
          })}
        </div>
      )}
    </button>
  );
};

export default WorkspaceFilter;
